const webOrder = {
  createBrokerWebOrder() {
    return `/weborder/submit/broker`;
  },
  uploadFile() {
    return `/weborder/attachment?rid=${crypto.randomUUID()}`;
  },
  uploadFileToCase(id) {
    return `/weborder/${id}/attachment`;
  },
  removeFile(fileId) {
    return `/weborder/attachment/${fileId}/remove`;
  },
  removeFileFromCase(id, fileId) {
    return `/weborder/${id}/attachment/${fileId}/remove`;
  },
  localTime(postalCode) {
    return `/weborder/localTime/${postalCode}`;
  },
  lenders() {
    return `/weborder/lenders`;
  },
  reportTypes(lender) {
    return `/weborder/lenders/${lender}/report-types`;
  },
  holidays() {
    return `/weborder/lenders/holidays`;
  },
  cancelCheckout(token) {
    return `/weborder/checkout/${token}/cancel`;
  },
  getCheckout(token) {
    return `/weborder/checkout/${token}`;
  },
  saveCheckout(token) {
    return `/weborder/checkout/${token}`;
  },
  getBillingPreview() {
    return "/weborder/billing";
  },
  getSettings() {
    return `/weborder/settings`;
  },
  submitWebOrder() {
    return `/weborder/submit/weborder`;
  },
};

export default webOrder;